import { Box } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './styles.css';

const DentalInfoBeneficioForm = () => {
  function handleAngendar() {
    window.location.href = '#/homepage/saude/agendamento-odontologia';
  }

  return (
    <section id="dental-info-beneficio">
      <p className="body-title mt-4">Serviço:</p>
      <p
        className="h4 mt-4"
        style={{ color: '#838383', width: '100%', marginBottom: 20 }}
      >
        Filiados ao Sindilegis têm direito a usufruir do serviço odontológico da
        Porto Seguro Odonto, plano Bronze AD, um plano odontológico gratuito,
        com cobertura nacional, que garante cuidados de qualidade para o
        servidor e seus familiares. O plano não tem carência e para começar a
        utilizá-lo, basta se filiar! <br />
        Com uma ampla rede credenciada de mais de 100 prestadores de serviços,
        você pode escolher entre diversas clínicas e dentistas, facilitando o
        acesso aos serviços que você precisa. <br />
        <br />
        Confira a rede credenciada:{' '}
        <a
          href="https://www.portoseguro.com.br/porto-seguro-saude/rede-referenciada-odonto"
          target="+_blank"
          rel="noreferrer noopener"
        >
          Rede Credenciada
        </a>
        <br />
        <br />
        Confira a cobertura detalhada do plano Bronze AD:{' '}
        <a
          href="https://sindilegis.org.br/wp-content/uploads/2022/07/ODONTO-BRONZE-COBERTURA-DETALHADA-1-1.pdf"
          target="+_blank"
          rel="noreferrer noopener"
        >
          Cobertura
        </a>
        <br />
        <br />
        <strong>Odontolegis</strong> <br />
        Dentro do plano da Porto Seguro Odonto está a clínica Odontolegis,
        localizada nas dependências do Sindilegis, em Brasília, que oferece um
        atendimento odontológico moderno e de qualidade, disponível
        gratuitamente para você e seus dependentes. Com horários flexíveis de
        segunda a sexta, das 8h às 18h, e aos sábados, das 9h às 13h, a clínica
        está pronta para atender suas necessidades de saúde bucal.
        <br />
        <br />
        <strong>Benefícios adicionais</strong> <br />
        Os filiados ao Sindilegis têm acesso a uma ampla gama de procedimentos
        gratuitos, como diagnóstico, prevenção, dentística e endodontia. Para
        tratamentos que não estão cobertos pela Agência Nacional de Saúde
        Suplementar (ANS), a clínica oferece valores reduzidos e competitivos,
        incluindo clareamento, próteses, implantes, aparelho ortodôntico,
        harmonização facial e toxina botulínica.
        <br />
        <br />
        <strong>Quem pode utilizar o benefício?</strong> <br />
        Para aproveitar esse benefício, basta ser filiado ao Sindilegis e seguir
        alguns passos simples para o cadastro, tanto para você quanto para seus
        dependentes. <br />
        Os dependentes elegíveis incluem:
        <br />
        <ul style={{ marginLeft: '20px', paddingLeft: '20px' }}>
          <li>
            Cônjuge ou companheiro(a): é necessário apresentar Certidão de
            Casamento ou União Estável e CPF.
          </li>
          <li>
            Filhos(as) não emancipados(as) até 21 anos: apresentar RG ou
            Certidão de Nascimento e CPF.
          </li>
          <li>
            Filhos(as) até 24 anos, se estiverem estudando: RG ou Certidão de
            Nascimento, Declaração de Aluno Regular e CPF.
          </li>
          <li>
            Dependentes que você declara no Imposto de Renda: cópia do IR do ano
            anterior e CPF.
          </li>
          <li>
            Dependentes por decisão judicial: apresentar a cópia da decisão e
            CPF.
          </li>
        </ul>
        <br />
        <strong>Como fazer o cadastro?</strong>
        <ol style={{ marginLeft: '20px', paddingLeft: '20px' }}>
          <li>
            Entre em contato com o Núcleo de Benefícios do Sindilegis pelos
            telefones (61) 3214-7300, opção 2, ou envie um e-mail para
            beneficios@sindilegis.org.br.
          </li>
          <li>
            Acesse a rede credenciada: Visite o site da Porto Seguro e busque a
            clínica mais próxima a você. É simples! Basta inserir seu CPF ou
            optar por não informar, além de escolher o estado e a cidade.
          </li>
          <li>
            Gere sua carteirinha digital: Após o cadastro, você pode acessar sua
            carteirinha virtual através da Área do Cliente, facilitando o
            agendamento das consultas.
          </li>
        </ol>
        <br />
        Para mais informações ligue no telefone (61) 3246-2400.
      </p>
      <Box display="flex" justifyContent="center">
        <button
          className="mt-5"
          style={{
            backgroundColor: '#378587',
            padding: '16px 48px',
            color: '#fff',
            marginBottom: 20,
          }}
          onClick={() => handleAngendar()}
        >
          Agendar
        </button>
      </Box>
    </section>
  );
};

const mapStateToProps = () => {};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DentalInfoBeneficioForm);
